import Template from "../../component/Template.js";
import { useEffect, useRef } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import Select from "react-select";

// import 'datatables.net';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import $ from 'jquery';

import Loader from "../../component/Loader.js";
import DownloadLoader from "../../component/DownloadLoader.js";

export default function Readmission() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  // const tableRef = useRef(null);

  const [loading, setlodaing] = useState(false);
  const [loader, setLoader] = useState(1);
  const [admissionYears, setAdmissionYears] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [disciplines, setDisciplines] = useState([]);

  // 🔹 Selected values
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedDiscipline, setSelectedDiscipline] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remarkText, setRemarkText] = useState("");
  const [currentAction, setCurrentAction] = useState(null); // which action user chose
  const [currentStudent, setCurrentStudent] = useState(null); // selected student
  const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Students data
  const [students, setStudents] = useState([]);

  const [totalstudents, setTotal] = useState(0);

  const [activeEventData, setActiveEventData] = useState([]);

  const { http } = Api();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  //Active events
  useEffect(() => {
    const fetchPrincipalEvents = async () => {
      try {
        const response = await http.get(`/College/getPrincipalEvents`);
        setActiveEventData(response.data.principalEvents); // update key if needed
      } catch (error) {
        if (
          error.response?.data?.http_status === 403 &&
          error.response?.data?.status_code === "ERR37"
        ) {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        } else if (
          error.response?.data?.http_status === 429 &&
          error.response?.data?.status_code === "ERR33"
        ) {
          toast.error(error.response.data.message);
        } else if (
          error.response?.data?.http_status === 500 &&
          error.response?.data?.status_code === "ERR5"
        ) {
          toast.error("No principal events found");
        } else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchPrincipalEvents();
  }, []);

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get(`/College/getReadmissionYear`);

        // Adjusted mapping for your response
        const yearOptions = response.data.map((item) => ({
          value: item.admissionyear,
          label: item.admissionyear,
        }));

        setAdmissionYears(yearOptions);
      } catch (error) {
        handleApiError(error, "No admission years found");
      }
    };

    fetchAdmissionYears();
  }, []);

  // =========================================================
  // 2️⃣ Load Semesters when Admission Year selected
  // =========================================================
  const fetchSemesters = async (year) => {
    try {
      const response = await http.get(`/College/getReadmissionSemester`, {
        params: {
          admissionyear: year,
        },
      });

      // Response is an array, so map directly
      const options = response.data.map((item) => ({
        value: item.semester_no,
        label: item.semester_name,
      }));

      setSemesters(options);
      setSelectedSemester(null);
      setDisciplines([]);
      setStudents([]);
    } catch (error) {
      handleApiError(error, "No semesters found");
    }
  };
  // =========================================================
  // 3️⃣ Load Disciplines when Year + Semester selected
  // =========================================================
  // =========================================================
  // 3️⃣ Load Disciplines when Admission Year & Semester are selected
  // =========================================================
  const fetchDisciplines = async (year, semester) => {
    try {
      const response = await http.get(`/College/getReadmissionDisciplines`, {
        params: { admissionyear: year, semester: semester },
      });

      const options = response.data.map((item) => ({
        value: item.discipline_id,
        label: item.discipline_name,
        courseType: item.college_course_type, // ✅ keep extra data
      }));

      setDisciplines(options);
    } catch (error) {
      handleApiError(error, "No disciplines found");
    }
  };

  // =========================================================
  // 4️⃣ Load Students when Discipline selected
  // =========================================================
  const fetchStudents = async (year, semester, discipline = null) => {
    try {
      const params = {
        admissionyear: year,
        semester: semester,
      };

      // only add discipline filters if selected
      if (discipline) {
        params.discipline_id = discipline.value;
        params.college_course_type = discipline.courseType;
      }

      const response = await http.get(`/College/getReadmissionStudents`, {
        params,
      });

      const studentsObj = response.data.students || {};
      const studentsArray = Object.values(studentsObj);

      setTableData(studentsArray);
    } catch (error) {
      handleApiError(error, "No students found");
    }
  };

  // =========================================================
  // Common API Error Handler
  // =========================================================
  const handleApiError = (error, defaultMessage) => {
    if (
      error.response?.data?.http_status === 403 &&
      error.response?.data?.status_code === "ERR37"
    ) {
      toast.error("Invalid Token");
      setTimeout(() => navigate("/college/"), 5000);
    } else if (
      error.response?.data?.http_status === 429 &&
      error.response?.data?.status_code === "ERR33"
    ) {
      toast.error(error.response.data.message);
    } else if (
      error.response?.data?.http_status === 500 &&
      error.response?.data?.status_code === "ERR5"
    ) {
      toast.error(defaultMessage);
    } else {
      toast.error("Something went wrong");
    }
  };
  const saveReadmissionAction = async (student, action, remarks = "") => {
    try {
      await http.post(`/College/saveReadmissionApproval`, {
        accountid: student.accountid,
        semester: student.semester,
        readmission_id: student.readmission_id, // confirm if this is same field name
        remarks: remarks,
        action: action,
      });

      toast.success("Action completed successfully");

      // reload student list after action
      fetchStudents(
        selectedYear.value,
        selectedSemester.value,
        selectedDiscipline
      );
    } catch (error) {
      handleApiError(error, "Failed to update action");
    }
  };

  // =========================================================
  // Handlers for Dropdown Changes
  // =========================================================
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setSelectedSemester(null);
    setSelectedDiscipline(null);
    setSemesters([]);
    setDisciplines([]);
    setTableData([]);

    if (selectedOption) fetchSemesters(selectedOption.value);
  };

  const handleSemesterChange = async (selectedOption) => {
    setSelectedSemester(selectedOption);
    setSelectedDiscipline(null);
    setDisciplines([]);
    setTableData([]);

    if (selectedOption && selectedYear) {
      await fetchDisciplines(selectedYear.value, selectedOption.value);
      await fetchStudents(selectedYear.value, selectedOption.value); // ✅ fetch unfiltered students
    }
  };

  const handleDisciplineChange = async (selectedOption) => {
    setSelectedDiscipline(selectedOption);
    setTableData([]);

    if (selectedOption && selectedSemester && selectedYear) {
      await fetchStudents(
        selectedYear.value,
        selectedSemester.value,
        selectedOption
      );
    } else if (!selectedOption && selectedSemester && selectedYear) {
      // if discipline cleared → show all students again
      await fetchStudents(selectedYear.value, selectedSemester.value);
    }
  };
  const handleActionClick = (student, action) => {
    if (action === "principal_revert") {
      // open popup to collect remarks
      setCurrentStudent(student);
      setCurrentAction(action);
      setShowRemarkModal(true);
    } else {
      // directly call API for approve or forward
      saveReadmissionAction(student, action);
    }
  };
  const handlePrintCertificateFromRow = async (row) => {
    try {
      const { http } = Api();
  
      // Get accountid and semester from the row data
      const accountId = row.accountid; // Adjust property name if different
      const semester = row.semester;   // Adjust property name if different
  
      if (!accountId) {
        toast.error("Student account ID not found");
        return;
      }
  
      const response = await http.get("College/readmissionCertificatePdf", {
        params: {
          accountid: accountId,
          semester: semester,
        },
        responseType: "blob",
      });
  
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = `ReadmissionCertificate_${accountId}_${semester}.pdf`;
      a.click();
  
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Unable to download certificate");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter data based on search term
  const filteredStudents = tableData.filter((student) => {
    const search = searchTerm.toLowerCase();

    return (
      search === "" ||
      student.apaar_no.toLowerCase().includes(search) ||
      student.studentname.toLowerCase().includes(search) ||
      student.prn.toLowerCase().includes(search)
    );
  });

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <>{loader === 1 ? <Loader /> : <DownloadLoader />}</>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h4>Readmission List</h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div class="table-container"></div>
                        <div className="table-responsive">
                          <div className="form theme-form">
                            <div className="card-body custom-input">
                              <div className="row">
                                <div className="col-md-4">
                                  <label>
                                    Admission Year{" "}
                                    <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    options={admissionYears}
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                    placeholder="Select Year"
                                    isClearable
                                  />
                                </div>

                                <div className="col-md-4">
                                  <label>
                                    Semester <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    options={semesters}
                                    value={selectedSemester}
                                    onChange={handleSemesterChange}
                                    placeholder="Select Semester"
                                    isDisabled={!selectedYear}
                                  />
                                </div>

                                <div className="col-md-4">
                                  <label>
                                    Discipline{" "}
                                    <span className="errorclr"></span>
                                  </label>
                                  <Select
                                    options={disciplines}
                                    value={selectedDiscipline}
                                    onChange={handleDisciplineChange}
                                    placeholder="Select Discipline (optional)"
                                    isDisabled={!selectedSemester}
                                  />
                                </div>
                              </div>
                              <div className="row m-t-20">
                                <div className="col-md-6">
                                  <label>Search (APAAR / Name / PRN)</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by APAAR, Name or PRN..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                  />
                                </div>
                              </div>

                              <div className="table-responsive">
                                <table
                                  className="table table-striped table-strip-bod"
                                  id="dataTable"
                                  style={{ marginBottom: "50px" }}
                                >
                                  <thead className="table-primary">
                                    <tr
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <th
                                        scope="col"
                                        width="5%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Sl No.
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          width: "10%",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        APAAR / PRN
                                      </th>

                                      <th
                                        scope="col"
                                        width="20%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Name
                                      </th>
                                      <th
                                        scope="col"
                                        width="10%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Semester
                                      </th>
                                      <th
                                        scope="col"
                                        width="10%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Readmission Year
                                      </th>
                                      <th
                                        scope="col"
                                        width="20%"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "#fff",
                                        }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {filteredStudents.length > 0 ? (
                                      filteredStudents.map((row, index) => (
                                        <tr key={index}>
                                          <td
                                            className="txt-aln"
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {index + 1}
                                          </td>
                                          <td
                                            style={{
                                              whiteSpace: "normal",
                                              wordWrap: "break-word",
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {row.apaar_no}/
                                            <br />
                                            {row.prn}
                                          </td>

                                          <td
                                            className="txt-aln"
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {row.studentname}
                                          </td>
                                          <td
                                            className="txt-aln"
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {row.semester}
                                          </td>
                                          <td
                                            className="txt-aln"
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {row.readmissionyear}
                                          </td>

                                          {/* --- ACTION BUTTONS --- */}
                                          <td
                                            data-label="Action"
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            <div
                                              className="txt-aln d-flex justify-content-center gap-2"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {/* 🔹 Forward Button */}
                                              {row.btn_fwd_uty === 1 && (
                                                <button
                                                  className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                                  onClick={() =>
                                                    handleActionClick(
                                                      row,
                                                      "forward_uty"
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-share-square"></i>{" "}
                                                  Forward
                                                </button>
                                              )}

                                              {/* 🔸 Revert Button */}
                                              {row.btn_revert === 1 && (
                                                <button
                                                  className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                                  onClick={() =>
                                                    handleActionClick(
                                                      row,
                                                      "principal_revert"
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-undo"></i>{" "}
                                                  Revert
                                                </button>
                                              )}

                                              {/* 🟢 Approve Button */}
                                              {row.btn_principal_aprv === 1 && (
                                                <button
                                                  className="btn btn-success btn-sm d-flex align-items-center gap-1"
                                                  onClick={() =>
                                                    handleActionClick(
                                                      row,
                                                      "principal_approve"
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-check-circle"></i>{" "}
                                                  Approve
                                                </button>
                                              )}

                                              {row.btn_prt_cert === 1 && (
                                                <div
                                                className="txt-aln"
                                                style={{ cursor: "pointer" }}
                                              >
                                                <i
                                                className="fa fa-print icn-out-bod"
                                                aria-hidden="true"
                                                title="Print Certificate"
                                                onClick={() => handlePrintCertificateFromRow(row)}
                                              ></i>
                                              </div>
                                              )}
                                            </div>

                                            {/* ✅ Show action message only when no buttons are visible */}
                                            {row.btn_fwd_uty === 0 &&
                                              row.btn_revert === 0 &&
                                              row.btn_principal_aprv === 0 && 
                                              row.btn_prt_cert ===0 &&
                                              row.action_message && (
                                                <div className="text-center mt-1 small text-muted">
                                                  {row.action_message}
                                                </div>
                                              )}

                                            {/* Modal for remarks */}
                                            {showRemarkModal && (
                                              <div
                                                className="modal fade show d-block"
                                                tabIndex="-1"
                                                role="dialog"
                                                style={{
                                                  backgroundColor:
                                                    "rgba(0, 0, 0, 0.2)", // lighter backdrop
                                                  backdropFilter: "blur(2px)", // optional: subtle blur effect
                                                }}
                                              >
                                                <div
                                                  className="modal-dialog modal-dialog-centered"
                                                  role="document"
                                                  style={{ maxWidth: "500px" }} // limit modal width
                                                >
                                                  <div className="modal-content p-3 shadow-lg rounded-3">
                                                    <h5 className="modal-title mb-3 text-center fw-semibold text-dark">
                                                      Enter Revert Remark
                                                    </h5>

                                                    <textarea
                                                      className="form-control mb-3"
                                                      value={remarkText}
                                                      onChange={(e) =>
                                                        setRemarkText(
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder="Enter remarks..."
                                                      rows={4}
                                                      style={{
                                                        resize: "vertical", // only allow vertical growth
                                                        minHeight: "100px", // prevent shrinking below this height
                                                        overflow: "auto", // add scrollbar if content grows too much
                                                      }}
                                                    />

                                                    <div className="d-flex justify-content-end gap-2 mt-2">
                                                      <button
                                                        className="btn btn-secondary"
                                                        onClick={() => {
                                                          setShowRemarkModal(
                                                            false
                                                          );
                                                          setRemarkText("");
                                                        }}
                                                      >
                                                        Cancel
                                                      </button>
                                                      <button
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                          if (
                                                            !remarkText.trim()
                                                          ) {
                                                            toast.error(
                                                              "Please enter a remark"
                                                            );
                                                            return;
                                                          }
                                                          setShowRemarkModal(
                                                            false
                                                          );
                                                          saveReadmissionAction(
                                                            currentStudent,
                                                            currentAction,
                                                            remarkText
                                                          );
                                                          setRemarkText("");
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="txt-aln">
                                          No data available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
